import script from "./LabelWithValue.vue?vue&type=script&setup=true&lang=js"
export * from "./LabelWithValue.vue?vue&type=script&setup=true&lang=js"

import "./LabelWithValue.vue?vue&type=style&index=0&id=32b07e7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b07e7c"]])

export default __exports__